import { Checkbox, FormControlLabel, Grid2, Typography } from "@mui/material";
import React, { Fragment, useEffect } from "react";
import CommonAccordion from "../../../common-components/CommonAccordion";
import PrimaryInformationCoversheetIco from "../../../../assets/icons/PrimaryInformationCoversheetIco";
import MixedComponent from "../../components/MixedComponent";
import AdditionalInformationCoversheetIco from "../../../../assets/icons/AdditionalInformationCoversheetIco";
import ExperienceCoversheetIco from "../../../../assets/icons/ExperienceCoversheetIco";
import EducationCoversheetIco from "../../../../assets/icons/EducationCoversheetIco";
import CertificateCoversheetIco from "../../../../assets/icons/CertificateCoversheetIco";
import ELCTable from "../../components/ELCTable";
import PreScreenQuestion from "../../components/PreScreenQuestion";
import CommonFileData from "../../../common-components/CoverSheetFunction";
import { useFormikContext } from "formik";
import Experience from "../../components/Experience";
import References from "../../components/References";
import { CommonGrid2 } from "../../../common-components/StyledComponents";
import { CustomizeSpan, ErrorContent } from "../../../jobs/style";

export default function Confirmation({
  handleChangeAccor,
  primaryData,
  isLoading,
  additionalInforamtion,
  previous_experience_with_client,
  previous_tax_term,
  previous_visa_status,
  handleExperienceEdit,
  handleExperienceDelete,
  view_resume,
  handleElcEdit,
  handleDeleteELC,
  expandedPanel,
  handleElcDialog,
  handleDeleteReferenceClick,
  handleAddReference,
  form,
  lg,
  customAttachmentData,
  setCustomAttachmentData,
  coverSheet,
  handleAnotherFunction,
}) {
  const { values, errors, setFieldValue } = useFormikContext();

  const handleRemoveFile = (index, item) => {
    const updated = customAttachmentData.find((_, i) => i === index);
    let fieldKey = "";

    if (updated.name === "EAD") fieldKey = "ead_upload";
    else if (updated.name === "Visa Copy") fieldKey = "visa_copy_upload";
    else if (updated.name === "RTR") fieldKey = "rtr_upload";
    else if (updated.name === "Resume") fieldKey = "resume_upload";
    else if (updated.name === "LinkedIn PDF") fieldKey = "linkedIn_pdf";
    else if (updated.name === "Award/Recommendation Letter")
      fieldKey = "award_letter";

    if (!fieldKey) return;
    const files = values[fieldKey] || [];

    if (files.length > 1) {
      const filteredFiles = files.filter(
        (file) => file.name !== updated.filename
      );
      setFieldValue(fieldKey, filteredFiles);
    } else {
      setFieldValue(fieldKey, []);
    }
  };

  const handleCheck = (titleName, e) => {
    setFieldValue(titleName, e.target.checked);
  };

  const updateAttachment = (key, label, isMultiple = false) => {
    const files = values[key] || [];

    setCustomAttachmentData((prev) => {
      const filtered = prev.filter((item) => item.name !== label);
      if (files.length === 0) return filtered;
      if (isMultiple) {
        const newItems = files.map((fileItem) => ({
          name: label,
          file: [fileItem],
          filename: fileItem?.name,
          type: fileItem?.type,
        }));

        return [...filtered, ...newItems];
      } else {
        return [
          ...filtered,
          {
            name: label,
            file: files,
            filename: files[0]?.name,
            type: files[0]?.type,
          },
        ];
      }
    });
  };

  useEffect(() => {
    updateAttachment("ead_upload", "EAD", true);
  }, [values.ead_upload]);

  useEffect(() => {
    updateAttachment("visa_copy_upload", "Visa Copy", true);
  }, [values.visa_copy_upload]);

  useEffect(() => {
    updateAttachment("rtr_upload", "RTR", true);
  }, [values.rtr_upload]);

  useEffect(() => {
    updateAttachment("resume_upload", "Resume", true);
  }, [values.resume_upload]);

  useEffect(() => {
    updateAttachment("linkedIn_pdf", "LinkedIn PDF", true);
  }, [values.linkedIn_pdf]);

  useEffect(() => {
    updateAttachment("award_letter", "Award/Recommendation Letter", true);
  }, [values.award_letter]);

  useEffect(() => {
    updateAttachment("attachments", "Attachment", true);
  }, [values.attachments]);

  return (
    <Fragment>
      <Typography variant={lg ? "h3" : "body5"} fontWeight={500}>
        Thanks{" "}
        <CustomizeSpan color="#FA4F96" fontWeight={700}>
          {coverSheet?.personal_details?.candidate_first_name}
        </CustomizeSpan>{" "}
      </Typography>
      <Typography
        variant={lg ? "h6" : "body1"}
        fontWeight={400}
        marginTop={"12px"}
        width={lg ? "60%" : "100%"}
      >
        Kindly review and verify your data.
      </Typography>

      <Grid2 container spacing={2} marginTop={"10px"}>
        <Grid2 size={12}>
          <CommonAccordion
            buttonborder={true}
            wholeborder="none"
            icon={<PrimaryInformationCoversheetIco />}
            open={expandedPanel.includes("Primary Information")}
            onChange={handleChangeAccor("Primary Information")}
            title={"Primary Information"}
            fontWeight={700}
            children={
              <MixedComponent
                editData={primaryData}
                loading={isLoading.loading}
              />
            }
          />
        </Grid2>

        <Grid2 size={12}>
          <CommonAccordion
            buttonborder={true}
            wholeborder="none"
            title={"Additional Information"}
            fontWeight={700}
            icon={<AdditionalInformationCoversheetIco />}
            open={expandedPanel.includes("Additional Information")}
            onChange={handleChangeAccor("Additional Information")}
            children={
              <MixedComponent
                editData={additionalInforamtion}
                loading={isLoading.loading}
              />
            }
          />
        </Grid2>

        <Grid2 size={12}>
          <CommonAccordion
            buttonborder={true}
            wholeborder="none"
            fontWeight={700}
            icon={<AdditionalInformationCoversheetIco />}
            title={"Previous Experience With The Client"}
            open={expandedPanel.includes("Previous Experience With The Client")}
            onChange={handleChangeAccor("Previous Experience With The Client")}
            children={
              <MixedComponent
                loading={isLoading.loading}
                editData={previous_experience_with_client}
              />
            }
          />
        </Grid2>
        <Grid2 size={12}>
          <CommonAccordion
            buttonborder={true}
            wholeborder="none"
            fontWeight={700}
            icon={<AdditionalInformationCoversheetIco />}
            title={"Tax Information"}
            open={expandedPanel.includes("Tax Information")}
            onChange={handleChangeAccor("Tax Information")}
            children={
              <MixedComponent
                editData={previous_tax_term}
                loading={isLoading.loading}
              />
            }
          />
        </Grid2>
        <Grid2 size={12}>
          <CommonAccordion
            buttonborder={true}
            wholeborder="none"
            fontWeight={700}
            icon={<AdditionalInformationCoversheetIco />}
            title={"Citizenship Information"}
            open={expandedPanel.includes("Citizenship Information")}
            onChange={handleChangeAccor("Citizenship Information")}
            children={
              <MixedComponent
                editData={previous_visa_status}
                loading={isLoading.loading}
              />
            }
          />
        </Grid2>
        <Grid2 size={12}>
          <CommonAccordion
            title={"Experience"}
            buttonborder={true}
            wholeborder="none"
            fontWeight={700}
            icon={<ExperienceCoversheetIco />}
            open={expandedPanel.includes("Experience")}
            onChange={handleChangeAccor("Experience")}
            children={
              <Experience
                loading={isLoading.loading}
                data={values.job_history}
                form={form}
                title={"Add Experience"}
                handleExperienceEdit={handleExperienceEdit}
                handleExperienceDelete={handleExperienceDelete}
                view_resume={view_resume}
                handleAnotherFunction={handleAnotherFunction}
              />
            }
          />
        </Grid2>
        <Grid2 size={12}>
          <CommonAccordion
            disabled
            buttonborder={true}
            wholeborder="none"
            fontWeight={700}
            icon={<EducationCoversheetIco />}
            open={expandedPanel.includes("Education")}
            onChange={handleChangeAccor("Education")}
            title={"Education"}
            children={
              <ELCTable
                loading={isLoading.loading}
                data={values.qualifications}
                form={form}
                handleElcEdit={handleElcEdit}
                title={"Add Education"}
                handleDeleteELC={handleDeleteELC}
                view_resume={view_resume}
                condition={true}
                handleAnotherFunction={handleAnotherFunction}
              />
            }
          />
        </Grid2>
        <Grid2 size={12}>
          <CommonAccordion
            disabled={isLoading.loading || view_resume}
            title={"Licences"}
            buttonborder={true}
            wholeborder="none"
            fontWeight={700}
            icon={<CertificateCoversheetIco />}
            open={expandedPanel.includes("Licences")}
            onChange={handleChangeAccor("Licences")}
            customStyle={{
              "& .MuiAccordionSummary-content .MuiButtonBase-root": {
                padding: lg ? "7px 2rem" : "7px 0.5rem",
                fontSize: !lg && "13px",
              },
              "& .MuiButtonBase-root .MuiAccordionSummary-content": {
                margin: "0px !important",
              },
            }}
            customStyleButton={{
              maxWidth: lg ? "150px" : "130px",
              width: "100%",
            }}
            children={
              <ELCTable
                loading={isLoading.loading}
                data={values.licenses}
                form={form}
                handleElcEdit={handleElcEdit}
                title={"Add Licenses"}
                handleDeleteELC={handleDeleteELC}
                view_resume={view_resume}
              />
            }
            accordionButton
            buttonTitle={"Add Licenses"}
            onButtonClick={() => handleElcDialog("Add Licenses", form)}
          />
        </Grid2>
        <Grid2 size={12}>
          <CommonAccordion
            buttonborder={true}
            wholeborder="none"
            fontWeight={700}
            icon={<CertificateCoversheetIco />}
            disabled={isLoading.loading || view_resume}
            title={"Certifications"}
            open={expandedPanel.includes("Certifications")}
            onChange={handleChangeAccor("Certifications")}
            customStyle={{
              "& .MuiAccordionSummary-content .MuiButtonBase-root": {
                padding: lg ? "7px 2rem" : "7px 0.5rem",
                fontSize: !lg && "13px",
              },
              "& .MuiButtonBase-root .MuiAccordionSummary-content": {
                margin: "0px !important",
              },
            }}
            customStyleButton={{
              maxWidth: lg ? "150px" : "130px",
              width: "100%",
            }}
            children={
              <ELCTable
                loading={isLoading.loading}
                form={form}
                data={values.certifications}
                handleElcEdit={handleElcEdit}
                title={"Add Certification"}
                handleDeleteELC={handleDeleteELC}
                view_resume={view_resume}
              />
            }
            accordionButton
            buttonTitle={"Add Certification"}
            onButtonClick={() => handleElcDialog("Add Certification", form)}
          />
        </Grid2>
        <Grid2 size={12}>
          <CommonAccordion
            buttonborder={true}
            wholeborder="none"
            fontWeight={700}
            icon={<CertificateCoversheetIco />}
            customStyleButton={{
              maxWidth: lg ? "150px" : "130px",
              width: "100%",
            }}
            accordionButton
            customStyle={{
              "& .MuiAccordionSummary-content .MuiButtonBase-root": {
                padding: lg ? "7px 2rem" : "7px 0.5rem",
                fontSize: !lg && "13px",
              },
              "& .MuiButtonBase-root .MuiAccordionSummary-content": {
                margin: "0px !important",
              },
            }}
            disabled={isLoading.loading || view_resume}
            title={"References"}
            buttonTitle={"Add Reference"}
            open={expandedPanel.includes("References")}
            onChange={handleChangeAccor("References")}
            children={
              <References
                data={values?.references || []}
                values={values}
                setFieldValue={setFieldValue}
                loading={isLoading.loading}
                handleDeleteReferenceClick={handleDeleteReferenceClick}
                disabled={isLoading.loading || view_resume}
              />
            }
            onButtonClick={() => handleAddReference("references", form)}
          />
        </Grid2>
        {values.pre_screen_question_answers?.length !== 0 && (
          <Grid2 size={12}>
            <CommonAccordion
              buttonborder={true}
              wholeborder="none"
              fontWeight={700}
              icon={<CertificateCoversheetIco />}
              title={"Pre-Screen Questions"}
              open={expandedPanel.includes("Pre-Screen Questions")}
              onChange={handleChangeAccor("Pre-Screen Questions")}
              children={
                <PreScreenQuestion
                  data={values.pre_screen_question_answers}
                  loading={isLoading.loading}
                  disabled={view_resume === "true" || isLoading.loading}
                />
              }
            />
          </Grid2>
        )}
        <Grid2 size={12}>
          <CommonAccordion
            buttonborder={true}
            wholeborder="none"
            title={"Attachments"}
            fontWeight={700}
            icon={<CertificateCoversheetIco />}
            open={expandedPanel.includes("Attachments")}
            onChange={handleChangeAccor("Attachments")}
            children={
              <CommonGrid2 spacing={2} container>
                <CommonFileData
                  handleRemoveFile={handleRemoveFile}
                  item={{
                    titleName: customAttachmentData,
                    uploadCustomSize: 4,
                  }}
                  values={customAttachmentData}
                />
              </CommonGrid2>
            }
          />
        </Grid2>
        <Grid2 size={12} marginTop={"-1rem"}>
          <FormControlLabel
            sx={{
              marginTop: "10px",
            }}
            control={
              <Checkbox
                checked={values.verified_check}
                disabled={view_resume || isLoading.loading}
                onChange={(e) => handleCheck("verified_check", e)}
              />
            }
            label="I verify that all the information provided is accurate."
          />
          {form.touched["verified_check"] && form.errors["verified_check"] && (
            <ErrorContent className="Mui-error">
              {form.errors["verified_check"]}
            </ErrorContent>
          )}
        </Grid2>
      </Grid2>
    </Fragment>
  );
}
